module.exports = __webpack_public_path__ + "img/chaplin_4.54660d3b.jpg";